module.exports = __webpack_public_path__ + "static/media/sad2Active.a73b7869.svg";